/** Um bloco da resposta: parágrafo, ou lista de itens. */
export type Bloco = { tipo: 'paragrafo'; texto: string } | { tipo: 'lista'; itens: string[] }

/**
 * A resposta do modelo em blocos, sem interpretar markdown.
 *
 * O prompt pede texto simples, com "- " para enumerar. Renderizar markdown de verdade abriria a
 * porta para o modelo (ou um trecho de documento citado por ele) injetar link e imagem na tela; aqui
 * só existem dois formatos, e tudo vira texto — o React escapa o resto.
 *
 * @param texto a resposta
 * @returns os blocos, na ordem
 */
export function blocosDaResposta(texto: string): Bloco[] {
  const blocos: Bloco[] = []
  let paragrafo: string[] = []
  let itens: string[] = []

  const fecharParagrafo = () => {
    if (paragrafo.length > 0) {
      blocos.push({ tipo: 'paragrafo', texto: paragrafo.join(' ') })
      paragrafo = []
    }
  }
  const fecharLista = () => {
    if (itens.length > 0) {
      blocos.push({ tipo: 'lista', itens })
      itens = []
    }
  }

  for (const bruta of texto.split(/\r?\n/)) {
    const linha = bruta.trim()
    const item = /^[-•*]\s+(.*)$/.exec(linha)
    if (item) {
      fecharParagrafo()
      itens.push((item[1] ?? '').replace(/\*\*/g, ''))
    } else if (linha === '') {
      fecharParagrafo()
      fecharLista()
    } else {
      fecharLista()
      paragrafo.push(linha.replace(/\*\*/g, ''))
    }
  }
  fecharParagrafo()
  fecharLista()
  return blocos
}
